import Error from '../model/Error';
import TrainerLicense from '../dto/TrainerLicense';
import axios from 'axios';

export default class ClubEmployeeTrainerLicenseRepository {

    static findTrainerLicenses(employeeId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/employees/${employeeId}/trainer-licenses`)
                .then(response => {
                    resolve(response.data.data.map(data => TrainerLicense.fromData(data)))
                })
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static createTrainerLicense(employeeId, trainerLicense) {

        return new Promise((resolve, reject) => {
            axios
                .post(`/club/employees/${employeeId}/trainer-license`, trainerLicense.toData())
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static removeTrainerLicense(employeeId, id) {
        return new Promise((resolve, reject) => {
            axios
                .delete(`/club/employees/${employeeId}/trainer-license/${id}`)
                .then(() => resolve())
                .catch(error => reject(Error.fromResponse(error.response)));
        });
    }

    static updateAll(employeeId, trainerLicenses) {
        return Promise.all(trainerLicenses.map(trainerLicense => {
            return new Promise((resolve, reject) => {
                axios
                    .put(`/club/employees/${employeeId}/trainer-license/${trainerLicense.id}`, trainerLicense.toData())
                    .then(() => resolve())
                    .catch(error => reject(Error.fromResponse(error.response)));
            });
        }));
    }

    static all(calls) {
        return Promise.all(calls);
    }
}
